import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DashboardService } from '../../_services/main/dashboard.service';
import { CsrService } from '../../_services/main/csr.service';
import { AuthService } from '../../_services/main/auth.service';
import { NegotiatorService } from '../../_services/main/negotiator.service';
import Swal from 'sweetalert2';
import { AccountCardComponent } from '../../portalV2/account/account-card.component';
import { EMPLOYEES, onboardingTypeToNameMap } from '../../../../config/common-lists';
import { FindValueSubscriber } from 'rxjs/operators/find';

@Injectable()
export class PortalV2Service {
  /////////////////////////////////////// Events
  @Output()
  GotAccountSavingsEvent: EventEmitter<any> = new EventEmitter();
  public $onCardMovementPush: EventEmitter<any> = new EventEmitter();
  public $onNotificationsPush: EventEmitter<any> = new EventEmitter();
  public $onTextMsgRecieve: EventEmitter<any> = new EventEmitter();
  public chatNotificationNumber = 0;
  public $pubnumEmitter: EventEmitter<any> = new EventEmitter();

  showHeader = true;
  public hostUrl: any = environment.API_BASE_URL;

  /////////////////////////////////////// Sharable Objects
  currentUser: any;
  customerDetails: any;
  cardDetails: any;
  charges: any;
  savings: any;
  accountSavings: any;
  refunds: any;
  disputes: any;
  activityLogs: any;
  activityLogsTime: any;
  callLogs: any;
  accounts: any;

  latestTexts: any = [];

  assigneeMap = [];
  onboardingTypeToNameMap = onboardingTypeToNameMap;

  accountSavingMap: any = [];
  account: any;
  ratings: any;
  referrals: any;
  onBoardingFlowName: any;
  totalChargeDifference: any;
  allowedStages: any;
  stageDisplayName: any;
  tagsAvailable: any;
  rootConfig: any;
  billProviders: any;
  marketingStats: any;

  conversationDetails = {
    messages: {
      inboundCount: 0,
      outboundCount: 0
    },
    emails: []
  };

  summary: any = {
    signupOn: '',
    totalSavings: 0,
    totalCharges: 0,
    totalRefunds: 0,
    totalScheduledAmount: 0, // to be collected in future
    lastTextSendOn: '',
    lastCallMadeOn: '',
    validAccounts: [],
    skippedAccounts: [],
    cityState: ''
  };

  /////////////////////////////////////// Sharable Flags
  accessAllowed = true;
  isCableActive = false;
  hasCC = false;
  hasAccounts = false;
  editCreditCard = false;
  showCreditCardForm = false;
  billPdf = false;

  /////////////////////////////////////// Sharable Arrays

  /////////////////////////////////////// Sharable Variables
  cellphoneProviderName: any;

  constructor(
    private _dashboardService: DashboardService,
    private _csrService: CsrService,
    private _authService: AuthService,
    private _negotiatorService: NegotiatorService,
    private _http: HttpClient,
    private handler: HttpBackend
  ) {
    // TODO: Code Review - I will rename this to LOGGED_IN_USER & loggedInUser
    this.getCurrentUser(); // logged in employee info
    this._dashboardService.getEmployees({}).subscribe(
      response => {
        this.assigneeMap = response.data.employee;
        this.reloadCustomerAssignees();
        this.reloadAccountAssignees();
      },
      error => {}
    );
  }

  resetSummary() {
    this.summary = {
      signupOn: '',
      totalSavings: 0,
      totalCharges: 0,
      totalRefunds: 0,
      totalScheduledAmount: 0,
      lastTextSendOn: '',
      lastCallMadeOn: '',
      validAccounts: [],
      skippedAccounts: [],
      cityState: ''
    };
  }

  /////////////////////////////////////// GET
  getCustomerDetailsByTaskID(taskId, empId, ignoreExistingCopy = false) {
    if (!ignoreExistingCopy && this.customerDetails) {
      return this.customerDetails;
    }
    this.allowedStages = null;
    this.stageDisplayName = null;
    const data = {
      cardId: !taskId.startsWith('id-') ? taskId : 'undefined',
      customerId: taskId.startsWith('id-') ? taskId.replace('id-', '') : ''
    };
    return new Promise((res, rej) => {
      this._dashboardService.getCustomerByCardId(data).subscribe(
        (response: any) => {
          this.resetSummary();
          this.helperProcessCustomerDetails(response);
          this.getMagicUrl({
            email: this.customerDetails.email,
            phone: this.customerDetails.phone,
            sc: 'billtrim#143@mindyourownbusiness-dev'
          });
          res(response || {});
        },
        (error: any) => {
          this.alert('error', 'Error', 'Something went wrong', 4000);
          rej({});
        },
        () => {}
      );
    });
  }
  getCustomerDetails(custId, ignoreExistingCopy = false) {
    if (!ignoreExistingCopy && this.customerDetails) {
      return this.customerDetails;
    }
    this._dashboardService.fetchUserAccountDetails(custId).subscribe(
      (response: any) => {
        this.helperProcessCustomerDetails(response);
      },
      (error: any) => {
        this.alert('error', 'Error', 'Something went wrong', 4000);
      },
      () => {}
    );
  }

  getMagicUrl(query) {
    this._dashboardService.getMagicUrl(query).subscribe(
      (response: any) => {
        this.customerDetails.magicUrl = response.data.result ? response.data.result.url : null;
      },
      (error: any) => {
        this.alert('error', 'Error', 'Something went wrong', 4000);
      },
      () => {}
    );
  }
  // TODO: Code Review - I will rename this to just getCustomerCharges
  getChargesSummary(custId, ignoreExistingCopy = false) {
    if (this.charges && !ignoreExistingCopy) {
      this.getSavingsSummary(this.customerDetails._id); // dependent on getChargesSummary hence calling it here
      return this.charges;
    }

    this._csrService.fetchChargesSummary(custId).subscribe((response: any) => {
      if (response.result && response.result.paymentRecords) {
        this.charges = response.result.paymentRecords;

        this.charges.sort(function(a, b) {
          if (a.scheduleDate && b.scheduleDate) {
            var dateA = +new Date(a.scheduleDate),
              dateB = +new Date(b.scheduleDate);
            return dateA - dateB;
          } else {
            var dateA = +new Date(a.createdAt),
              dateB = +new Date(b.createdAt);
            return dateA - dateB;
          }
        });

        this.charges.map(i =>
          i.type !== 'hold' &&
          i.type !== 'release' &&
          i.type !== 'refund' &&
          !i.scheduleDate &&
          i.charge_id
            ? (this.summary.totalCharges += parseFloat(i.charges))
            : 0
        );
        this.charges.map(i =>
          i.type === 'refund' ? (this.summary.totalRefunds += parseFloat(i.charges)) : 0
        );
        this.charges.map(i =>
          i.scheduleDate ? (this.summary.totalScheduledAmount += parseFloat(i.charges)) : 0
        );

        // this.summary.totalRefunds = this.summary.totalRefunds / 100;
        this.getSavingsSummary(this.customerDetails._id); // dependent on getChargesSummary hence calling it here
        this.getCustomerAccounts(this.customerDetails._id);
      } else {
        this.getSavingsSummary(this.customerDetails._id);
      }
    });
  }
  // TODO: Code Review - I will rename this to just getCustomerSavings
  getSavingsSummary(custId, ignoreExistingCopy = false) {
    if (this.savings && !ignoreExistingCopy) {
      return this.savings;
    }

    this._csrService.fetchCustomerSavingsSummary(custId).subscribe((response: any) => {
      if (response.data && response.data.saving) {
        this.savings = response.data.saving;

        this.savings.sort(function(a, b) {
          var dateA = +new Date(a.createdAt),
            dateB = +new Date(b.createdAt);
          return dateA - dateB;
        });

        this.summary.totalSavings = 0;
        this.savings.map(i => {
          this.summary.totalSavings += i.totalSavings;
          this.accountSavingMap[i.type] = i.totalSavings;
        });
      }
      this.totalChargeDifference = 0;
      this.totalChargeDifference = Math.abs(
        this.summary.totalCharges
          ? this.summary.totalSavings * 0.25 -
              this.summary.totalCharges -
              this.summary.totalScheduledAmount
          : this.summary.totalSavings * 0.25
      );
    });
  }
  // TODO: Code Review - I will rename this to just getAccountSavings
  getAccountSavingsSummary(accountId, ignoreExistingCopy = false) {
    if (this.accountSavings && !ignoreExistingCopy) {
      return this.accountSavings;
    }

    this._csrService.fetchAccountSavingsSummary(accountId).subscribe((response: any) => {
      if (response.data && response.data.saving) {
        this.accountSavings = response.data.saving;
        // sort by desc of createdAt
        this.accountSavings.sort(function(a, b) {
          var dateA = +new Date(a.createdAt),
            dateB = +new Date(b.createdAt);
          return dateB - dateA;
        });

        this.GotAccountSavingsEvent.emit({
          success: true,
          message: 'savings for account received'
        });
      }
    });
  }

  getRefundHistory(custId, ignoreExistingCopy = false) {
    if (this.refunds && !ignoreExistingCopy) {
      return this.refunds;
    }

    this._csrService.fetchCustomerRefundHistory(custId).subscribe((response: any) => {
      if (response.result && response.result.refundRecords) {
        this.refunds = response.result.refundRecords;
      }
    });
  }
  getDisputeStats(employee_id, customerMail) {
    if (this.disputes) {
      return this.disputes;
    }

    this._csrService.getCSRStats({ employee_id, customerMail }).subscribe(
      (response: any) => {
        if (response.data) {
          this.disputes = response.data.custDispute;
        }
      },
      (error: any) => {},
      () => {}
    );
  }
  getCustomerActivityLogs(custId, ignoreExistingCopy = false) {
    if (this.activityLogs && !ignoreExistingCopy) {
      return this.activityLogs;
    }

    this._dashboardService.fetchUserActivities(custId).subscribe(
      (response: any) => {
        if (response.data && response.data.activityLogs) {
          this.activityLogs = response.data.activityLogs.logs.reverse();
          this.activityLogsTime = response.data.activityLogs.updatedAt;
          for (const log of this.activityLogs) {
            //log.className = this.getRandomStateClass();
            log.className = log.tagColor;

            if (log.type === 'sendMessage') {
              this.summary.lastTextSendOn = log.createdAt;
            }
            if (log.type === 'call') {
              this.summary.lastCallMAdeOn = log.createdAt;
            }
          }
        }
      },
      (error: any) => {
        this.alert('error', 'Error', 'Something went wrong', 4000);
      },
      () => {}
    );
  }
  // TODO: Code Review - I will rename this to just getCustomerCallLogs
  getCalls(phone) {
    if (this.callLogs) {
      return this.callLogs;
    }

    this._dashboardService.fetchCalls(phone).subscribe((response: any) => {
      if (response.result.calls && response.result.calls.length) {
        this.callLogs = [];
        response.result.calls.forEach(call => {
          if (call.recordingURL) {
            // TODO: Code Review - write comment why splitting
            this.callLogs.push({
              recordingURL: call.recordingURL,
              url: call.recordingURL.split('.mp3')[0] + '.mp3',
              play: false,
              pause: true,
              duration: call.duration,
              fromNumber: call.fromNumber,
              toNumber: call.toNumber,
              createdAt: call.createdAt
            });
          }
        });
      }
    });
  }
  getCustomerAccounts(custId, ignoreExistingCopy = false) {
    return new Promise((resolve, reject) => {
      if (this.accounts && !ignoreExistingCopy) {
        resolve(this.accounts);
      }

      this._dashboardService.fetchAccounts(custId).subscribe(
        (response: any) => {
          if (response.data.account && response.data.account.length) {
            this.accounts = response.data.account;
            this.summary.skippedAccounts = [];
            this.summary.validAccounts = [];
            for (const account of this.accounts) {
              if (account.isSkipped) {
                console.log('skipped');
                const skippedAccount = {
                  type: account.type,
                  negotiatorName: 'NA',
                  status: 'SKIPPED',
                  saving: 0
                };
                this.summary.skippedAccounts.push(skippedAccount);
              } else {
                console.log('not skipped');

                const validAccount = {
                  account_id: account._id,
                  accountCardId: account.accountCardId,
                  date: account.createdAt,
                  type: account.type,
                  negotiatorName: '',
                  qaName: '',
                  technicalIssueDescription: account.technicalIssueDescription,
                  hasCredentials: account.username && account.password ? true : false,
                  providerName: account.providerName,
                  boardId: account.boardId || '',
                  stageId: account.stageId || '',
                  providerId: account.provider_id,
                  hasPin: account.pin ? true : false,
                  hasPdf: account.files.length ? true : false,
                  saving: this.accountSavingMap[account.type]
                    ? this.accountSavingMap[account.type]
                    : 0,
                  isBundleMain: account.isBundleMain
                };

                if (account.negotiatorId) {
                  const emp = this.assigneeMap.filter(emp => emp._id == account.negotiatorId);
                  if (emp.length > 0) {
                    validAccount.negotiatorName = emp[0].fullname;
                  } else {
                    validAccount.negotiatorName = '❓Name Missing';
                  }
                } else {
                  validAccount.negotiatorName = '❓Not Assigned';
                }

                if (account.qaId) {
                  const emp = this.assigneeMap.filter(emp => emp._id == account.qaId);
                  if (emp.length > 0) {
                    validAccount.qaName = emp[0].fullname;
                  } else {
                    validAccount.qaName = '❓Name missing';
                  }
                } else {
                  validAccount.qaName = '❓Not Assigned';
                }

                this.summary.validAccounts.push(validAccount);
              }

              if (account.type === 'cellphone' && this.billProviders) {
                this.cellphoneProviderName = this.getProviderName(
                  account.type,
                  account.provider_id
                );
              }

              resolve(this.accounts);
            }
            this.getMagicUrl({
              email: this.customerDetails.email,
              phone: this.customerDetails.phone,
              sc: 'billtrim#143@mindyourownbusiness-dev'
            });
          } else {
            reject('Something went wrong');
          }
        },
        error => {
          reject('Something went wrong');
        }
      );
    });
  }
  async getAccountDetailsByTaskID(cardId, empId) {
    this._dashboardService.fetchNegoTask(cardId, empId).subscribe(
      (response: any) => {
        if (
          response.data &&
          response.data.result &&
          response.data.account &&
          response.data.account.length
        ) {
          this.account = response.data.account[0];
          this.account.providerName = this.getProviderName(
            this.account.type,
            this.account.provider_id
          );
          this.cardDetails = response.data.card;

          this.reloadAccountAssignees();

          this.getCustomerDetails(
            response.data.account[0].customerId || response.data.account[0].cust_id
          );
          this.getSavingsSummary(
            response.data.account[0].customerId || response.data.account[0].cust_id
          );
          this.getAccountSavingsSummary(response.data.account[0]._id);

          if (this.account.bundleType != null) {
            const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getRootConfig'));
            if (API_RESPONSE && API_RESPONSE.data.bundleTypes) {
              const accountBundle = API_RESPONSE.data.bundleTypes.filter(
                bundleConfig => bundleConfig.bundleId === this.account.bundleType
              )[0];
              this.account.bundleDisplayName = accountBundle.displayName || '';
            }
          }
        } else {
          this.alert('error', 'Error', 'No Account found linked to this clickup card');
        }
      },
      (error: any) => {
        this.alert('error', 'Error', 'An attempt to fetch account details failed. Try again!');
      },
      () => {}
    );
  }

  reloadAccountAssignees() {
    if (!this.account) return;
    let negotiatorId;
    // first preference is given to card assignment not account assignment
    if (
      this.cardDetails &&
      this.cardDetails.negotiatorEmployee &&
      this.cardDetails.negotiatorEmployee.employeeId
    ) {
      negotiatorId = this.cardDetails.negotiatorEmployee.employeeId;
    } else if (this.account.negotiatorId) {
      negotiatorId = this.account.negotiatorId;
    }

    if (negotiatorId) {
      const emp = this.assigneeMap.filter(emp => emp._id == negotiatorId);
      if (emp.length > 0) {
        this.account.negotiatorName = emp[0].fullname;
      } else {
        this.account.negotiatorName = '❓Name missing';
      }
    } else {
      this.account.negotiatorName = '❓Not Assigned';
    }

    let qaId;
    // first preference is given to card assignment not account assignment
    if (this.cardDetails && this.cardDetails.qaEmployee && this.cardDetails.qaEmployee.employeeId) {
      qaId = this.cardDetails.qaEmployee.employeeId;
    } else if (this.account.qaId) {
      qaId = this.account.qaId;
    }
    if (qaId) {
      const emp = this.assigneeMap.filter(emp => emp._id == qaId);
      if (emp.length > 0) {
        this.account.qaName = emp[0].fullname;
      } else {
        this.account.qaName = '❓Name Missing';
      }
    } else {
      this.account.qaName = '❓Not Assigned';
    }
  }

  // TODO: Code Review - rename to getAccountDetailsByID
  getAccountByID(accountId) {
    this._dashboardService.fetchAccount(accountId).subscribe(
      (response: any) => {
        if (
          response.data &&
          response.data.result &&
          response.data.account &&
          response.data.account.length
        ) {
          this.account = response.data.account[0];
          this.account.providerName = this.getProviderName(
            this.account.type,
            this.account.provider_id
          );
          this.getCustomerDetails(response.data.account[0].customerId);
          this.getSavingsSummary(response.data.account[0].customerId);
          this.getAccountSavingsSummary(accountId);
        } else {
          this.alert('error', 'Error', 'No Account found linked to this clickup card');
        }
      },
      (error: any) => {
        this.alert('error', 'Error', 'An attempt to fetch account details failed. Try again!');
      },
      () => {}
    );
  }

  getLatestTexts(customerId) {
    this._dashboardService.fetchLatestTexts(customerId).subscribe(
      (response: any) => {
        if (response.status && response.result) {
          const { messages = {}, latestConversation = '' } = response.result || {};
          this.latestTexts = messages[latestConversation] || [];
        } else {
          this.latestTexts = [];
          // this.alert('error', 'Error', 'Fetching latest text for a given customer failed');
        }
      },
      (error: any) => {
        // this.alert(
        //   'error',
        //   'Error',
        //   'An attempt to fetch latest text for a given failed. Try again!'
        // );
      },
      () => {}
    );
  }
  /////////////////////////////////////// POST | Update

  /////////////////////////////////////// DELETE

  /////////////////////////////////////// HELPERS
  helperProcessCustomerDetails(response) {
    if (response.data && response.data.result && response.data.customer != null) {
      this.customerDetails = response.data.customer;
      if (response.data.card) {
        this.cardDetails = response.data.card;
      }
      if (this.customerDetails.notes) {
        // sort in createdAt Desc
        this.customerDetails.notes.sort(function(a, b) {
          var dateA = +new Date(a.createdAt),
            dateB = +new Date(b.createdAt);
          return dateA - dateB;
        });
      }
      if (this.customerDetails.card && this.customerDetails.card.stripe_id) {
        this.hasCC = true;
      }
      this.reloadCustomerAssignees();

      if (this.customerDetails.accounts) {
        this.hasAccounts = true;
      }
      if (this.customerDetails.card && this.customerDetails.card.stripe_id) {
        this.editCreditCard = true;
        this.showCreditCardForm = false;
      } else {
        this.showCreditCardForm = true;
        this.editCreditCard = false;
      }
      if (this.customerDetails.onboardingType) {
        this.onBoardingFlowName = 'Flow: ' + onboardingTypeToNameMap[41]; // default
        if (onboardingTypeToNameMap[this.customerDetails.onboardingType]) {
          this.onBoardingFlowName =
            'Flow: ' + onboardingTypeToNameMap[this.customerDetails.onboardingType];
        }
      }
      if (this.customerDetails.campaign) {
        this.onBoardingFlowName += ` | Source: ${this.customerDetails.campaign.source ||
          'no source'} | Campaign: ${this.customerDetails.campaign.campaign || 'no campaign'}`;
      } else {
        this.onBoardingFlowName += ` | Source: Organic`;
      }

      this.summary.signupOn = this.customerDetails.createdAt;

      if (this.customerDetails.address) {
        this.summary.cityState = `${this.customerDetails.address.city} - ${this.customerDetails.address.state}`;
      } else if (this.customerDetails.ipData) {
        this.summary.cityState = `${this.customerDetails.ipData.city} - ${this.customerDetails.ipData.state}`;
      }

      this.getCustomerActivityLogs(this.customerDetails._id);
      this.getChargesSummary(this.customerDetails._id);
      this.getRatingRefferalDetails(this.customerDetails._id);
      this.getDisputeStats(this.currentUser._id, this.customerDetails.email);
      this.getCustomerStageMap();
      this.getConversationDetails('phone');
      this.getLatestTexts(this.customerDetails.phone);
    } else {
      this.alert('error', 'No user', 'No customer found for the task', 4000);
      // todo Send him to search a customer
    }
  }

  reloadCustomerAssignees() {
    if (!this.customerDetails) return;
    if (this.customerDetails.csrId) {
      const emp = this.assigneeMap.filter(emp => emp._id == this.customerDetails.csrId);
      if (emp.length > 0) {
        this.customerDetails.csrName = emp[0].fullname;
      } else {
        this.customerDetails.csrName = '❓Name Missing';
      }
    } else {
      this.customerDetails.csrName = '❓Not Assigned';
    }

    if (this.customerDetails.chaserId) {
      const emp = this.assigneeMap.filter(emp => emp._id == this.customerDetails.chaserId);
      if (emp.length > 0) {
        this.customerDetails.chaserName = emp[0].fullname;
      } else {
        this.customerDetails.chaserName = '❓Name Missing';
      }
    } else {
      this.customerDetails.chaserName = '❓Not Assigned';
    }
  }

  // TODO: Code Review - this does not belong in helpers. Move it above. Rename to getRatingRefferalByCustomer
  getRatingRefferalDetails(custId, ignoreExistingCopy = false) {
    if (!ignoreExistingCopy && this.ratings) {
      return this.ratings;
    }

    if (!ignoreExistingCopy && this.referrals) {
      return this.referrals;
    }

    this._dashboardService.fetchRating(custId).subscribe(
      (response: any) => {
        this.ratings = response.result.rating;
      },
      (error: any) => {
        this.alert('error', 'Error', 'Something went wrong', 4000);
      },
      () => {}
    );

    this._dashboardService.fetchRefferal(custId).subscribe(
      (response: any) => {
        this.referrals = response.result.refferal;
      },
      (error: any) => {
        this.alert('error', 'Error', 'Something went wrong', 4000);
      },
      () => {}
    );
  }
  alert(type, title, text, time?) {
    Swal({
      type: type,
      title: title,
      text: text,
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: time || 3000
    }).then(() => {});
  }
  formatPhoneNumber(s) {
    const s2 = ('' + s).replace(/\D/g, '');
    const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3];
  }
  secondsToMinutes(time) {
    return Math.floor(time / 60) + ':' + Math.floor(time % 60);
  }
  play(cLog) {
    let logIndex = -1;
    $('#audio-player').attr('src', cLog.url);
    this.callLogs.forEach((item, i) => {
      if (cLog.url === item.url) {
        logIndex = i;
      } else {
        this.callLogs[i].play = false;
        this.callLogs[i].pause = true;
      }
    });
    const audio = <HTMLAudioElement>document.getElementById('audio-player');
    if (cLog.pause) {
      audio.play();
      $('#audio-player').show();
      this.callLogs[logIndex].play = true;
      this.callLogs[logIndex].pause = false;
    } else {
      audio.pause();
      $('#audio-player').hide();
      audio.currentTime = 0;
      this.callLogs[logIndex].play = false;
      this.callLogs[logIndex].pause = true;
    }
  }
  getFormattedDate(dateStr) {
    const dt = new Date(dateStr);
    const month = dt.getMonth() + 1;
    const day = dt.getDate();
    const year = dt.getFullYear();
    return month + '/' + day + '/' + year;
  }
  // getRandomStateClass() {
  //   const classes = [
  //     'success',
  //     'warning',
  //     'danger',
  //     'info',
  //     'primary',
  //     'brand',
  //     'accent',
  //     'focus',
  //     'metal'
  //   ];
  //   return classes[Math.floor(Math.random() * classes.length)];
  // }
  getPdfSignedURL(pdfFileName) {
    return this._negotiatorService.getSignedURL(pdfFileName);
  }

  getCustomerStageMap() {
    if (this.allowedStages && this.rootConfig) {
      this.getStageDisplayName();
      return this.rootConfig;
    }
    this._csrService.getRootConfig().subscribe(resp => {
      this.rootConfig = resp.data;
      this.getStageDisplayName();
      for (const stage of this.rootConfig.stageConfigs) {
        if (stage[this.cardDetails.stageId]) {
          this.allowedStages = stage[this.cardDetails.stageId][0].dispositionsAvailable;
          console.log('allowedStages', this.allowedStages);
          this.tagsAvailable = stage[this.cardDetails.stageId][0].tagsAvailable;
          if (
            stage[this.cardDetails.stageId][0].visibleToEmployeeTypes.indexOf(
              this.currentUser.type
            ) < 0
          ) {
            this.accessAllowed = false;
          }
          break;
        }
      }
    });
  }
  fetchProviders() {
    this._dashboardService.fetchProviders().subscribe(
      (response: any) => {
        console.log(response);
        if (response.data.result) {
          this.billProviders = response.data.provider;
        } else {
          this.alert('error', 'Error', 'Could not fetch the provider details, please try again');
        }
      },
      (error: any) => {
        console.log(error);
      },
      () => {}
    );
  }

  getStageDisplayName() {
    if (this.cardDetails) {
      for (const board of this.rootConfig.boardsStagesMapping) {
        for (const stage of board.stages) {
          if (stage.name === this.cardDetails.stageId) {
            this.stageDisplayName =
              'Board: ' + board.boardDisplayName + ' | Stage: ' + stage.displayName;
            if (this.cardDetails.subStageId) {
              this.stageDisplayName +=
                ' | Substage: ' + this.cardDetails.subStageId.split(/-(.+)/)[1];
            }
            break;
          }
        }
      }
    }
  }
  getMarketingStats(filters) {
    // if (this.disputes) {
    //   return this.disputes;
    // }
    this._csrService.marketingStats(filters).subscribe(
      (response: any) => {
        this.marketingStats = [];
        if (response.data) {
          let prevDate = response.data[0].received_at.value;
          let num_visitors = 0;
          let num_signed_up_clicked = 0;
          let num_customers = 0;
          let num_customers_one_cred = 0;
          let num_customers_gave_cc = 0;
          for (const stat of response.data) {
            if (prevDate === stat.received_at.value) {
              num_visitors += stat.num_visitors ? stat.num_visitors : 0;
              num_signed_up_clicked += stat.num_signed_up_clicked ? stat.num_signed_up_clicked : 0;
              num_customers += stat.num_customers ? stat.num_customers : 0;
              num_customers_one_cred += stat.num_customers_one_cred
                ? stat.num_customers_one_cred
                : 0;
              num_customers_gave_cc += stat.num_customers_gave_cc ? stat.num_customers_gave_cc : 0;
            } else {
              const obj = {
                campaign_campaign: 'All Traffic',
                type: 'sum',
                num_visitors: num_visitors,
                num_signed_up_clicked: num_signed_up_clicked,
                num_customers: num_customers,
                num_customers_one_cred: num_customers_one_cred,
                num_customers_gave_cc: num_customers_gave_cc,
                received_at: {
                  value: prevDate
                }
              };
              this.marketingStats.push(obj);
              prevDate = stat.received_at.value;
              num_visitors = stat.num_visitors ? stat.num_visitors : 0;
              num_signed_up_clicked = stat.num_signed_up_clicked ? stat.num_signed_up_clicked : 0;
              num_customers = stat.num_customers ? stat.num_customers : 0;
              num_customers_one_cred = stat.num_customers_one_cred
                ? stat.num_customers_one_cred
                : 0;
              num_customers_gave_cc = stat.num_customers_gave_cc ? stat.num_customers_gave_cc : 0;
            }
            stat['index'] = response.data.indexOf(stat) + 1;
            this.marketingStats.push(stat);
          }
          //this.marketingStats = response.data;
        }
      },
      (error: any) => {},
      () => {}
    );
  }
  getMarketing12HoursStats(filters) {
    this._csrService.marketing12HourStats(filters).subscribe(resp => {
      this.marketingStats = resp.data.marketingResult[0];
      let totalCardVerfied = 0;
      let totalCustomerCount = 0;
      for (const stat of this.marketingStats.hours) {
        totalCardVerfied += stat.cardVerified ? stat.cardVerified : 0;
        totalCustomerCount += stat.customerCount ? stat.customerCount : 0;
      }
      const obj = {
        type: 'total',
        cardVerified: totalCardVerfied,
        customerCount: totalCustomerCount
      };
      this.marketingStats.hours.push(obj);
    });
  }

  async clearPortalData() {
    this.savings = null;
    this.charges = null;
    this.refunds = null;
    this.customerDetails = null;
    this.cardDetails = null;
    this.accountSavings = null;
    this.activityLogs = null;
    this.activityLogsTime = null;
    this.callLogs = null;
    this.accounts = null;
    this.accountSavingMap = [];
    this.account = null;
    this.ratings = null;
    this.referrals = null;
    this.onBoardingFlowName = null;
    this.totalChargeDifference = null;
    this.allowedStages = null;
    this.stageDisplayName = null;
    this.tagsAvailable = null;
    this.billProviders = null;
    this.marketingStats = null;

    this.hasCC = false;
    this.accessAllowed = true;
    this.isCableActive = false;
    this.hasAccounts = false;
    this.editCreditCard = false;
    this.showCreditCardForm = false;
    this.billPdf = false;
  }

  getEstimatedSavings(data): Observable<any> {
    const httpClient = new HttpClient(this.handler); // to avoid interceptor
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization:
          'token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YWVhY2ZiZjEyNDVhODBiZjAzNjYzNmIiLCJ0eXBlIjowLCJpYXQiOjE1MjUzMzgwNDh9.io4vy830_TTtYF36ZnwYqyJXdUSNwF4hDsYEMrsHwmU'
      })
    };
    return httpClient
      .post(`${this.hostUrl}api/getCalculatedSaving`, data, httpOptions)
      .map((res: Response) => res);
  }

  getProviderName(billType, providerId) {
    let providerName = '';
    if (this.billProviders) {
      const providerObj = this.billProviders[billType].find(i => i._id === providerId);
      if (providerObj && providerObj.name) {
        providerName = providerObj.name;
      }
    }
    return providerName;
  }

  getConversationDetails(type) {
    if (type === 'phone') {
      this._dashboardService
        .getCustomerConversationDetails('phone', this.customerDetails.phone)
        .subscribe(
          (response: any) => {
            if (response && response.status) {
              this.conversationDetails.messages = {
                inboundCount: response.result.inboundMessagesCount || 0,
                outboundCount: response.result.outboundMessagesCount || 0
              };
            }
          },
          (error: any) => {
            // this.alert(
            //   'error',
            //   'Error',
            //   'Something went wrong during getConversationDetails phone',
            //   4000
            // );
          },
          () => {}
        );
    } else if (type === 'email') {
      this._dashboardService
        .getCustomerConversationDetails('email', this.customerDetails.email)
        .subscribe(
          (response: any) => {
            if (response && response.status) {
              this.conversationDetails.emails = response.result.mails;

              this.conversationDetails.emails.sort(function(a, b) {
                var dateA = +new Date(a.time),
                  dateB = +new Date(b.time);
                return dateA - dateB;
              });
            }
          },
          (error: any) => {
            // this.alert(
            //   'error',
            //   'Error',
            //   'Something went wrong during getConversationDetails emails ',
            //   4000
            // );
          },
          () => {}
        );
    }
  }

  getDaysAgo(createdAt: any) {
    const timeMilliSeconds = Math.ceil(
      Math.abs(new Date(createdAt).getTime() - new Date().getTime())
    );

    const seconds = Math.round(timeMilliSeconds / 1000);

    const minutes = Math.round(timeMilliSeconds / (1000 * 60));

    const hours = Math.round(timeMilliSeconds / (1000 * 60 * 60));

    const days = Math.round(timeMilliSeconds / (1000 * 60 * 60 * 24));

    if (seconds < 60) {
      return '<' + 1 + ' min';
    } else if (minutes < 60) {
      return minutes + ' min';
    } else if (hours < 48) {
      return hours + ' hrs';
    } else {
      return days + ' days';
    }
  }

  calculateAge(dateString) {
    if (!dateString) {
      return 'NoDOB';
    }

    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    let ageLabel = '';
    if (age > 64) {
      ageLabel = 'GenX+';
    } else if (age > 44) {
      ageLabel = 'GenX';
    } else {
      ageLabel = 'GenX-';
    }
    return ageLabel;
  }

  getCheckBackDate(dateString, contractTerm) {
    if (!dateString) {
      return '';
    }
    var result = new Date(dateString);
    result.setDate(result.getDate() + (30 * contractTerm + 7));
    return result;
  }

  toggleHeader() {
    const body = document.getElementsByTagName('body')[0];
    const header = document.getElementById('m_header');
    if (body.classList.contains('m-header--fixed')) {
      body.classList.remove('m-header--fixed');
      body.classList.remove('m-header--fixed-mobile');
      header.style.display = 'none';
      this.showHeader = false;
    } else {
      body.classList.add('m-header--fixed');
      body.classList.add('m-header--fixed-mobile');
      header.style.display = 'block';
      this.showHeader = true;
    }
  }

  toggleFullScreen(divID) {
    const element = document.getElementById(divID);
    if (element.classList.contains('fullscreen')) {
      element.classList.remove('fullscreen');
    } else {
      element.classList.add('fullscreen');
    }
  }

  copyToClipboard(text: string) {
    const copyText: any = document.createElement('input');
    copyText.value = text;
    copyText.style.cssText = 'position: absolute;top: -999999px';
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    copyText.blur();
  }

  copyLinks(linkType: string, accountType?: string, shorten?: string) {
    console.log(this.customerDetails);
    let magiclink = this.customerDetails.magicUrl.replace('page=onboarding', '');
    const empReferralCode = this.currentUser.referralCode;
    if (linkType === 'creditcard') {
      magiclink = `${magiclink}page=fb&mod=add-cc&ref=${empReferralCode}`;
    } else if (linkType === 'billLink') {
      magiclink = `${magiclink}page=fb&linkbill=${accountType ||
        this.account.type}&ref=${empReferralCode}`;
    } else if (linkType === 'pinLink') {
      magiclink = `${magiclink}page=fb&mod=edit-pin&linkbill=${accountType ||
        this.account.type}&ref=${empReferralCode}`;
    } else if (linkType === 'gabilink') {
      magiclink = `${magiclink}page=fb&linkbill=auto&partner=gabi&ref=${empReferralCode}`;
    } else if (linkType === 'dashboard') {
      magiclink = `${magiclink}page=dashboard&ref=${empReferralCode}`;
    } else if (linkType === 'billpay_dashboard') {
      magiclink = `${magiclink}page=billpay_dashboard&ref=${empReferralCode}`;
    } else if (linkType === 'moreBills') {
      magiclink = `${magiclink}page=fb&mod=add-more-bills&ref=${empReferralCode}`;
    } else if (linkType === 'recommendLink') {
      magiclink = `${magiclink}page=fb&mod=recommend&ref=${empReferralCode}`;
    }
    if (linkType === 'referralLink') {
      let referralLink = '';
      if (this.customerDetails.referralCode) {
        referralLink = `https://billtrim.com/?rc=${this.customerDetails.referralCode}&ref=${empReferralCode}`;
      }
      if (shorten) {
        this.shortenAndCopy(referralLink);
      } else {
        this.copyToClipboard(referralLink);
      }
    } else {
      if (shorten) {
        this.shortenAndCopy(magiclink);
      } else {
        this.copyToClipboard(magiclink);
      }
    }
  }

  getCurrentUser() {
    this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
  }

  shortenAndCopy(url) {
    const urlObj: any = { url };
    this._dashboardService.shortenUrl(urlObj).subscribe(
      (response: any) => {
        if (response.data && response.data.url) {
          this.copyToClipboard(response.data.url);
          this.alert('success', 'Done!', 'Copied');
        }
      },
      (error: any) => {
        this.alert('error', 'Error', 'Something went wrong', 4000);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/portalv2.service.ts